import { z } from "zod";

export const IndicatorFrequencySchema = z.enum(["daily", "weekly", "monthly", "quarterly", "yearly"]);
export type IndicatorFrequency = z.infer<typeof IndicatorFrequencySchema>;

export const IndicatorFrequencys = {
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
  quarterly: "quarterly",
  yearly: "yearly",
} as const;

export const ALLOWED_INDICATOR_FREQUENCIES = Object.values(IndicatorFrequencys);

export const indicatorFrequencyFromString = (str: string): IndicatorFrequency | undefined => {
  const key = str.toLowerCase() as IndicatorFrequency;
  return IndicatorFrequencys[key] || undefined;
};

export const sortIndicatorFrequency = (a?: string | null | undefined, b?: string | null | undefined): number => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  return a.localeCompare(b);
};
